import { styled } from "styled-components";

export const Screen = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100dvh;
  width: 100%;
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 600px;
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.h1`
  font-size: 48px;
  font-weight: 700;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

export const Description = styled.h1`
  font-size: ${({ theme }) => theme.fonts.medium.fontSize};
  line-height: 1.5;
  text-align: center;
  padding: 0 ${({ theme }) => theme.spacing[2]};
`;
